import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  focusStyles: {
    '&:focus': {
      outline: 'none',
      backgroundColor: theme.palette.grey[200]
    }
  }
}));

const Caption = ({ messageId }) => {
  const classes = useStyles();
  const tabIndex = 0;

  return (
    <div className={classes.focusStyles} tabIndex={tabIndex}>
      <FormattedMessage id={messageId} />
    </div>
  );
};

Caption.propTypes = {
  messageId: PropTypes.string
};

export default Caption;
